/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useMemo, useEffect, lazy ,Suspense  } from 'react'
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom"
import { StoreContext } from "redux-react-hook"
import { getSearch } from 'utils/utils'
import { RouterPaths } from 'utils/constant'
import { $login, clearLoginInfo } from 'service/sign'
import { $affSendCode } from 'service/affiliate'
import store from 'store'
import Loading from 'components/loading'
import { isMobile } from 'utils/utils'
const ForgetEmail = lazy(() => import('pages/sign/Forget-email'))
const SignInPhone = lazy(() => import("pages/sign/SignIn-phone"))
const SignInQr = lazy(() => import("pages/sign/SingIn-qr"))
const ForgetPhone = lazy(() => import("pages/sign/Forget-phone"))
const Affiliate = lazy(() => import("pages/affiliate/index"))
const SignInEmail = lazy(() => import("pages/sign/SignIn-email"))
const ActivityPage = lazy(() => import("pages/activity/index"))
const ActivityLitePage = lazy(() => import("pages/activityLite/index"))
const AffiliateWithdrawRecords = lazy(() => import("pages/affiliate/WithdrawRecords")) 
const AffiliateAwardRecords = lazy(() => import("pages/affiliate/AwardRecords")) 
const Recharge = lazy(() => import('pages/recharge')) 
const Menu = lazy(() => import('pages/menu/menu')) 
const Thanks = lazy(() => import('./pages/thanks-for-using/index' )) 
const ResetPasswd = lazy(() => import('pages/sign/Reset-password'))
const Shop = lazy(() => import('pages/shop/index'))

const routes = [
  {
    path: RouterPaths["signin-email"],
    component: SignInEmail
  },
  {
    path: RouterPaths["forget-email"],
    component: ForgetEmail
  },
  {
    path: RouterPaths["signin-phone"],
    component: SignInPhone
  },
  {
    path: RouterPaths["signin-qr"],
    component: SignInQr
  },
  {
    path: RouterPaths["forget-phone"],
    component: ForgetPhone
  },
  {
    path: RouterPaths["reset-password"],
    component: ResetPasswd
  },
  {
    path: RouterPaths.home,
    component: Recharge
  },
  {
    path: RouterPaths.menu,
    component: Menu,
    auth: true,
    parameters: true,
  },
  {
    path: RouterPaths.myAffiliate,
    component: Affiliate,
    auth: true,
  },
  {
    path: RouterPaths.affiliateWithdrawRecords,
    component: AffiliateWithdrawRecords,
    auth: true,
  },
  {
    path: RouterPaths.affiliateAwardRecords,
    component: AffiliateAwardRecords,
    auth: true,
  },
  {
    path: RouterPaths.thanksForUsing,
    component: Thanks,
    auth: true,
  },
  {
    path: RouterPaths.Activity,
    component: ActivityPage,
    // auth: true,
  },
  {
    path: RouterPaths.ActivityLite,
    component: ActivityLitePage,
    // auth: true,
  },
  {
    path: RouterPaths.shop,
    component: Shop,
  },
]

const redirectRoutes = [
  {
    path: "/payment/thanks-for-using",
    redirect: RouterPaths.thanksForUsing
  },
  // {
  //   path: "/payment/activity",
  //   redirect: RouterPaths.Activity
  // },
  {
    path: "/payment/signin",
    redirect: RouterPaths["signin-phone"]
  },
  {
    path: "/payment/signup",
    redirect: RouterPaths["signin-phone"]
  },
  // {
  //   path: RouterPaths["signin-phone"],
  //   redirect: RouterPaths["signin-email"]
  // },
  {
    path: '/',
    redirect: RouterPaths.home
  },
]

const App: React.FC = () => {
  return (
    <StoreContext.Provider value={store}>
      <AppRouter />
    </StoreContext.Provider>
  )
}

const AppRouter: React.FC = () => {
  useEffect(() => {
    const source = getSearch('source')
    const place = getSearch('place')
    const loginToken = getSearch('login-token')
    const redirect = getSearch('redirect')
    const affiliateCode = getSearch('affiliate-code')

    if (source) {
      sessionStorage.setItem('source', source || '')
    }
    place && sessionStorage.setItem('place', place || '')
    if (loginToken) {
      clearLoginInfo()
      $login(decodeURIComponent(loginToken))
        .then((res) => { 
          if(res.code===0){
            if (!res.data.phone_num) {
              // setLoginInfo(res.data, res.data.token.access_token)
              sessionStorage.setItem('bandemail',JSON.stringify(res.data))
              clearLoginInfo()
              console.log('当前账号未绑定手机号')
              // history.push(RouterPaths["forget-email"])
              window.location.href = `/payment/signin-email?qridLogin=true${redirect ? '&redirect=' + redirect : ''  }`
            }else{
              if (redirect) {
                window.location.href = redirect
              }
            }
          }else{
            isMobile() ? window.location.href = '/payment/signin-phone' :window.location.href = '/payment/signin-qr'
          }
          
        })
    }
    if (affiliateCode) {
      $affSendCode(affiliateCode)
    }
  }, [])

  return useMemo(() => (
    <Suspense fallback={<Loading/>}>
      <Router>
        <Switch>
          {
            routes.map(R => {
              if (R.auth) {
                return privateRoute(R)
              }
              return render(R)
            })
          }
          {
            redirectRoutes.map(i => (
              <Redirect key={i.path} from={i.path} to={i.redirect} />
            ))
          }
        </Switch>
      </Router>
    </Suspense>

  ), [])
}

function render(R: any) {
  return (
    <Route
      key={R.path}
      path={R.parameters ? `${R.path}/:id` : R.path}
      exact
      component={R.component}
    />
  )
}

function privateRoute({ component: Component, ...rest }) {
  return (
    <Route
      key={rest.path}
      {...rest}
      path={rest.parameters ? `${rest.path}/:id` : rest.path}
      exact
      render={props => {
        return store.getState().user.logined ? (
          <Component {...props} />
        ) : (
          props.match.url === '/payment/thanks-for-using' ?
            <Component {...props} />
            : <Redirect
              to={{
                pathname: "/"
              }}
            />
        )
      }
      }
    />
  )
}

export default App
